import React from "react";
import { string, bool, object } from "prop-types";
import { ContentTextSection as SharedContentTextSection } from "../../sharedComponents/ContentTextSection";
import * as styles from "./ContentTextSection.module.scss";
// eslint-disable-next-line import/no-cycle
import { RichText } from "../RichText";

const ContentTextSection = ({ text, collapse, embeddedContent }) => (
	<>
		{embeddedContent && <RichText data={embeddedContent} />}
		{text && !embeddedContent && (
			<SharedContentTextSection text={text} collapse={collapse} styles={styles} />
		)}
	</>
);

ContentTextSection.propTypes = {
	text: string,
	collapse: bool,
	embeddedContent: object,
};
ContentTextSection.defaultProps = {
	text: null,
	collapse: false,
	embeddedContent: null,
};

export default ContentTextSection;
export { ContentTextSection };
